<template>
    <section>
        <div class="mt-5 stock-title">
            <h3><b-icon icon="card-text"></b-icon> รายการสัปดาห์ยาง</h3>
            <p>รายการสัปดาห์ยางด้านล่างจะเป็นรายการที่ยังไม่ถูกตัดสต๊อคจากรายการที่จองไว้</p>
        </div>

        <perfect-scrollbar class="mt-3">
            <table>
                <thead>
                    <tr>
                        <th>สัปดาห์ยาง</th>
                        <th class="text-center">ของร้าน</th>
                        <th class="text-center">สินค้าโป๊ว</th>
                        <th class="text-center">ฝากขาย</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in contentData.stockData.dots" :key="index" v-show="item.name">
                        <td :class="{ 'no-dot': !item.name }">{{ item.name || 'ไม่ระบุ' }}</td>
                        <td class="text-center">{{ item.amountNormal }}</td>
                        <td class="text-center">{{ item.amountSublet }}</td>
                        <td class="text-center">{{ item.amountConsign }}</td>
                        <td class="text-center"><button class="icon" @click="deleteDot(index, item.name)" v-if="item.name"><b-icon icon="trash"></b-icon></button></td>
                    </tr>
                </tbody>
            </table>
        </perfect-scrollbar>

        <div class="no-data" v-if="contentData.stockData.dots.length <= 1">
            <b-icon icon="exclamation-diamond"></b-icon>
            <span>ไม่มีรายการสัปดาห์ยาง</span>
        </div>

        <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="contentData.stockData.dots.length" class="mt-4"></paging>
    </section>
</template>

<script>
import DBStock from '@/database/Stock';

export default {
    data() {
        return {
            activePage: 1,
            pageSize: 10
        };
    },
    props: {
        contentData: Object
    },
    methods: {
        deleteDot(index, name) {
            this.$swal({
                title: 'ลบสัปดาห์ยาง?',
                text: 'โปรดยืนยันว่าต้องการลบสัปดาห์ยางและสต๊อคที่มีอยู่ทั้งหมด',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();
                    const stockData = await DBStock.getDetail(this.contentData.key);
                    stockData.dots.splice(index, 1);

                    await DBStock.deleteDot(stockData, this.contentData.key, name);

                    this.$emit('stockUpdate', stockData);
                    loader.hide();
                }
            });
        },
        changePage(page) {
            this.activePage = page;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/inventory/modalStock/StockContent.scss';
</style>